export default __webpack_public_path__ + "static/bio1-7050b89f28ce7861c75cdf37d9f46984.jpg";